export class BaseSheet {
  sheet_code: string
  nendo: string
  subject_code: string
  report_no: string
  sheet_type: number
  name: string
  passing_score: string
  qr_code: string
  publish_at: Date
  std_deadline_at: Date
  final_deadline_at: Date
  is_published: boolean
  is_print_part1: boolean
  is_print_part1_cache: boolean
  is_print_view_point: boolean
  is_print_view_point_cache: boolean
  is_use_student_info_field: boolean
  is_use_hosei: boolean
  score_positions_completed: boolean
  result_return_scheduled_at: string | null
  is_correct_image_publish: boolean

  get requiresFollowUpSettingPart1(): boolean{
    return this.is_print_part1 != this.is_print_part1_cache && this.is_print_part1;
  }

  get requiresFollowUpSettingViewPoint(): boolean{
    return this.is_print_view_point != this.is_print_view_point_cache && this.is_print_view_point;
  }

  get requiresFollowUpSetting(): boolean {
    return this.score_positions_completed && (this.requiresFollowUpSettingPart1 || this.requiresFollowUpSettingViewPoint);
  }

  constructor(baseSheet: any){
    this.sheet_code = baseSheet.sheet_code;
    this.nendo = baseSheet.nendo;
    this.subject_code = baseSheet.subject_code;
    this.report_no = baseSheet.report_no;
    this.sheet_type = baseSheet.sheet_type;
    this.name = baseSheet.name;
    this.passing_score = baseSheet.passing_score;
    this.qr_code = baseSheet.qr_code;
    this.publish_at = baseSheet.publish_at;
    this.std_deadline_at = baseSheet.std_deadline_at;
    this.final_deadline_at = baseSheet.final_deadline_at;
    this.is_published = baseSheet.is_published;
    this.is_print_part1 = baseSheet.is_print_part1;
    this.is_print_part1_cache = baseSheet.is_print_part1;
    this.is_print_view_point = baseSheet.is_print_view_point;
    this.is_print_view_point_cache = baseSheet.is_print_view_point;
    this.is_use_student_info_field = baseSheet.is_use_student_info_field;
    this.is_use_hosei = baseSheet.is_use_hosei;
    this.score_positions_completed = baseSheet.score_positions_completed;
    this.result_return_scheduled_at = baseSheet.result_return_scheduled_at;
    this.is_correct_image_publish = baseSheet.is_correct_image_publish;
  }
}
